export default __webpack_public_path__ + "static/media/Sketch Illustration.d6e22200.svg";